import React from "react";
import logoDark from "@/assets/img/logo-dark.svg";
import logo from "@/assets/img/logo.svg";
import { Link, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchCategories } from "@/redux/slices/categorySlice";
import { fetchUserInfo } from "../../redux/slices/userSlice";
import { logout } from "../../redux/slices/authSlice";
import { toast } from "react-toastify";
import { jwtDecode } from "jwt-decode";
import ChatService from "../../services/ChatService";
const Header = () => {
  const { user } = useSelector((state) => state.auth);
  const navigate = useNavigate();

  var userId = 0;
  if (user) {
    const decoded = jwtDecode(user);
    userId = decoded["sub"];
  } else {
    userId = 0;
  }

  const dispatch = useDispatch();
  const { categories, loading, error } = useSelector((state) => state.category);
  const [wishlistLength, setWishlistLength] = useState(0);
  const [roleName, setRoleName] = useState("");

  const { userInfo } = useSelector((state) => state.user);

  useEffect(() => {
    const fetchData = async () => {
      if (user) {
        try {
          const decoded = jwtDecode(user);
          const userId = decoded["sub"];
          await dispatch(fetchUserInfo(userId)).unwrap();
          localStorage.setItem("userId", JSON.stringify(userId));
        } catch (err) {
          dispatch(logout());
          toast.error(err.message || "Tài khoản đã bị logout!");
        }
      }
      dispatch(fetchCategories());
    };

    fetchData(); // Gọi hàm async bên trong useEffect
    ChatService.initSignalR();
  }, [dispatch, user]);
  useEffect(() => {
    const updateWishlist = () => {
      const wishlistExist =
        JSON.parse(localStorage.getItem(`wishlist_${userId}`)) || [];
      setWishlistLength(wishlistExist.length);
    };

    // Lắng nghe sự kiện
    window.addEventListener("wishlistUpdated", updateWishlist);

    // Gọi cập nhật lần đầu khi component mount
    updateWishlist();

    return () => {
      // Xóa lắng nghe khi component unmount
      window.removeEventListener("wishlistUpdated", updateWishlist);
    };
  }, [userId]);

  useEffect(() => {
    const hasToastBeenShown = sessionStorage.getItem("hasShownToast");

    if (user && userInfo && !hasToastBeenShown) {
      const decoded = jwtDecode(user);
      const roleName =
        decoded["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];
      setRoleName(roleName);
      if (roleName === "Tour guide" && userInfo?.checkGuide === false) {
        toast.warn("Vui lòng cập nhật thông tin để có thể nhận tour!");
        sessionStorage.setItem("hasShownToast", "true"); // Lưu trạng thái
        navigate("/update-user");
      }
    }
  }, [userInfo, navigate]);

  return (
    <div className="main-header main-header-four">
      {/* <!-- Header Topbar--> */}
      <div className="header-topbar header-top-six text-center bg-transparent">
        <div className="container">
          <div className="d-flex align-items-center justify-content-between flex-wrap">
            <div className="d-flex align-items-center flex-wrap">
              <p className="d-flex align-items-center fs-14 mb-2 me-3 ">
                <i className="isax isax-call5 me-2"></i>
                Số điện thoại : 0763794399
              </p>
              <p className="mb-2 d-flex align-items-center fs-14">
                <i className="isax isax-message-text-15 me-2"></i>Email :{" "}
                <a
                  href="https://dreamstour.dreamstechnologies.com/cdn-cgi/l/email-protection"
                  className="__cf_email__"
                  data-cfemail="fe97909891be9b869f938e929bd09d9193"
                >
                  dreamtour2025@gmail.com
                </a>
              </p>
            </div>
            <div className="navbar-logo mb-2">
              <a className="logo-dark header-logo" href="#">
                <img src={logoDark} className="logo" alt="Logo Dask" />
              </a>
              <a className="logo-white header-logo" href="#">
                <img src={logo} className="logo" alt="Logo" />
              </a>
            </div>
            <div className="d-flex align-items-center gap-3">
              {/* Dropdown */}
              {/* <div className="dropdown">
                <a
                  href="#"
                  className="dropdown-toggle"
                  data-bs-toggle="dropdown"
                >
                  USD
                </a>
                <ul className="dropdown-menu p-2 mt-2">
                  <li>
                    <a className="dropdown-item rounded" href="#">
                      USD
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item rounded" href="#">
                      YEN
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item rounded" href="#">
                      EURO
                    </a>
                  </li>
                </ul>
              </div> */}

              {/* Dark/Light Mode Toggle */}
              <div className="d-flex align-items-center gap-2">
                <a href="#" id="dark-mode-toggle" className="theme-toggle">
                  <i className="isax isax-moon"></i>
                </a>
                <a href="#" id="light-mode-toggle" className="theme-toggle">
                  <i className="isax isax-sun-1"></i>
                </a>
              </div>

              {/* Wishlist */}
              <div className="position-relative">
                <Link to="/wishlist">
                  <i className="isax isax-heart"></i>
                  <span className="count-icon bg-secondary text-gray-9">
                    {wishlistLength}
                  </span>
                </Link>
              </div>

              {/* User Login/Profile */}
              <div>
                {!user ? (
                  <Link
                    to="/login"
                    className="btn btn-dark"
                    data-bs-toggle="modal"
                    data-bs-target="#login-modal"
                  >
                    Đăng nhập
                  </Link>
                ) : (
                  <Link to="/my-profile">
                    <img
                      src={
                        userInfo && userInfo.imageUrl ? userInfo.imageUrl : ""
                      }
                      alt="img"
                      className="avatar avatar-md rounded-circle"
                      style={{
                        width: "35px",
                        height: "35px",
                        objectFit: "cover",
                      }}
                    />
                  </Link>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- /Header Topbar-->

        <!-- Header --> */}
      <header className="header-six">
        <div className="container">
          <div className="offcanvas-info">
            <div className="offcanvas-wrap">
              <div className="offcanvas-detail">
                <div className="offcanvas-head">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <a href="#" className="black-logo-responsive">
                      <img src={logoDark} alt="logo-img" />
                    </a>
                    <a href="#" className="white-logo-responsive">
                      <img src={logo} alt="logo-img" />
                    </a>
                    <div className="offcanvas-close">
                      <i className="ti ti-x"></i>
                    </div>
                  </div>
                  <div className="wishlist-info d-flex justify-content-between align-items-center">
                    <h6 className="fs-16 fw-medium">Wishlist</h6>
                    <div className="d-flex align-items-center">
                      <div className="fav-dropdown">
                        <a href="wishlist.html" className="position-relative">
                          <i className="isax isax-heart"></i>
                          <span className="count-icon bg-secondary text-gray-9">
                            0
                          </span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mobile-menu fix mb-3"></div>
                <div className="offcanvas__contact">
                  <div className="mt-4">
                    <div className="header-dropdown d-flex flex-fill">
                      <div className="w-100">
                        <div className="dropdown">
                          <a
                            href="#"
                            className="dropdown-toggle bg-white border d-block"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            USD
                          </a>
                          <ul className="dropdown-menu p-2">
                            <li>
                              <a className="dropdown-item rounded" href="#">
                                USD
                              </a>
                            </li>
                            <li>
                              <a className="dropdown-item rounded" href="#">
                                YEN
                              </a>
                            </li>
                            <li>
                              <a className="dropdown-item rounded" href="#">
                                EURO
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div>
                      <a
                        href="#"
                        className="text-white btn btn-dark w-100 mb-3"
                        data-bs-toggle="modal"
                        data-bs-target="#login-modal"
                      >
                        Sign In
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="offcanvas-overlay"></div>
          <div className="header-nav">
            <div className="main-menu-wrapper">
              <div className="navbar-logo">
                <a className="logo-white header-logo" href="#">
                  <img src={logo} className="logo" alt="Logo" />
                </a>
              </div>
              <nav id="mobile-menu">
                <ul className="main-nav">
                  <li className="has-submenu megamenu active">
                    <Link to="/">Trang chủ</Link>
                  </li>
                  <li className="has-submenu mega-innermenu">
                    <Link to="/tour-list">Tour</Link>
                  </li>
                  <li className="has-submenu mega-innermenu">
                    <a href="#">
                      Danh mục tour<i className="fa-solid fa-angle-down"></i>
                    </a>
                    <ul className="submenu mega-submenu">
                      <li>
                        <div className="megamenu-wrapper">
                          <div className="row g-lg-4">
                            {loading && <p>Đang tải danh mục...</p>}
                            {error && <p>Lỗi: {error}</p>}
                            {!loading && !error && (
                              <>
                                {categories.length > 0 ? (
                                  categories.map((category) => (
                                    <div className="col-lg-6" key={category.id}>
                                      <ul>
                                        <li>
                                          <Link
                                            to={`/tour-list?categoryId=${category.id}`}
                                          >
                                            {category.categoryName}
                                          </Link>
                                        </li>
                                      </ul>
                                    </div>
                                  ))
                                ) : (
                                  <p>Không có danh mục nào.</p>
                                )}
                              </>
                            )}
                          </div>
                        </div>
                      </li>
                    </ul>
                  </li>
                  {user && (
                    <li className="has-submenu mega-innermenu">
                      <a href="#">
                        Tour cá nhân hóa
                        <i className="fa-solid fa-angle-down"></i>
                      </a>

                      <ul className="submenu mega-submenu">
                        <li>
                          <div className="megamenu-wrapper">
                            <div className="row g-lg-4">
                              <div className="col-lg-6">
                                <ul>
                                  <li>
                                    <Link to="/chat-bot">Chat Bot AI</Link>
                                  </li>
                                  <li>
                                    <Link to="/create-tour-personalized">
                                      Tạo tour cá nhân hóa
                                    </Link>
                                  </li>
                                  <li>
                                    <Link to="/my-tour-personalized">
                                      Tour cá nhân hóa của bạn
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </li>
                  )}

                  <li className="has-submenu mega-innermenu">
                    {user ? (
                      <>
                        <Link to="/blog">
                          Blog<i className="fa-solid fa-angle-down"></i>
                        </Link>

                        <ul className="submenu mega-submenu">
                          <li>
                            <div className="megamenu-wrapper">
                              <div className="row g-lg-4">
                                <div className="col-lg-6">
                                  <ul>
                                    <li>
                                      <Link to="/blog">Tất cả Blog</Link>
                                    </li>
                                    <li>
                                      <Link to="/my-blog">Blog của tôi</Link>
                                    </li>
                                    {roleName === "Staff" && (
                                      <li>
                                        <Link to="/manage-blog">
                                          Quản lý Blog
                                        </Link>
                                      </li>
                                    )}
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </>
                    ) : (
                      <Link to="/blog">Blog</Link>
                    )}
                  </li>
                  {user ? (
                    <li className="has-submenu mega-innermenu">
                      {roleName === "Staff" ? (
                        <>
                          <Link to="/mini-game">
                            Mini game<i className="fa-solid fa-angle-down"></i>
                          </Link>

                          <ul className="submenu mega-submenu">
                            <li>
                              <div className="megamenu-wrapper">
                                <div className="row g-lg-4">
                                  <div className="col-lg-6">
                                    <ul>
                                      <li>
                                        <Link to="/mini-game">Mini game</Link>
                                      </li>
                                      <li>
                                        <Link to="/manage-mini-game">
                                          Tạo câu hỏi mini-game
                                        </Link>
                                      </li>
                                      <li>
                                        <Link to="/manage-setting-game">
                                          Quản lý cài đặt mini-game
                                        </Link>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </li>
                          </ul>
                        </>
                      ) : (
                        <Link to="/mini-game">Mini-game</Link>
                      )}
                    </li>
                  ) : (
                    <li className="has-submenu mega-innermenu">
                      <Link to="/mini-game">Mini-game</Link>
                    </li>
                  )}
                  <li className="has-submenu megamenu">
                    <Link to="/contact-us">Liên hệ</Link>
                  </li>
                </ul>
              </nav>
              <div className="header-btn align-items-center">
                <div className="dropdown me-3">
                  <a
                    href="#"
                    className="dropdown-toggle"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    USD
                  </a>
                  <ul className="dropdown-menu p-2 mt-2">
                    <li>
                      <a className="dropdown-item rounded" href="#">
                        USD
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item rounded" href="#">
                        YEN
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item rounded" href="#">
                        EURO
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="me-3">
                  <a href="dashboard.html">
                    <i className="isax isax-user"></i>
                  </a>
                </div>
                <div className="fav-dropdown  me-3">
                  <a href="wishlist.html" className="position-relative">
                    <i className="isax isax-heart"></i>
                    <span className="count-icon bg-secondary text-gray-9">
                      0
                    </span>
                  </a>
                </div>
                <div>
                  <a
                    href="#"
                    className="text-white btn btn-dark w-100 mb-2"
                    data-bs-toggle="modal"
                    data-bs-target="#register-modal"
                  >
                    Sign In
                  </a>
                </div>
              </div>
              <div className="header__hamburger d-xl-none my-auto">
                <div className="sidebar-menu">
                  <i className="isax isax-menu5"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      {/* <!-- /Header --> */}
    </div>
  );
};

export default Header;
